/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na "CRON" plánovače obsahových úloh založených na kalendářích
 * @implements {ContentTaskCronFactory}
 */
class ContentTaskPlanCronFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ContentTaskPlanCron>} ContentTaskPlanCron
   * @param {ContentTaskComparator} comparator
   * @param {ContentTaskPlanIteratorFactory} iteratorFactory
   * @param {Timers} timers
   */
  constructor(ContentTaskPlanCron, comparator, iteratorFactory, timers) {
    this.ContentTaskPlanCron = ContentTaskPlanCron;
    this.comparator = comparator;
    this.iteratorFactory = iteratorFactory;
    this.timers = timers;
  }

  /** @inheritdoc */
  create(contentTasks) {
    return new this.ContentTaskPlanCron(
      this.comparator,
      contentTasks,
      this.iteratorFactory,
      this.timers
    );
  }
}

export default ContentTaskPlanCronFactory;
